import { Form, Input } from 'antd'
import { useEffect, useState } from 'react'

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: '请输入${label}',
}

export default function FormPage(props) {
  const { originForm } = props
  const [form] = Form.useForm(originForm)
  const [user, setUser] = useState({})

  useEffect(() => {
    const info = props.originForm.getFieldValue()
    setUser(info)
  }, [props])

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 18 }}
      validateMessages={validateMessages}
    >
      <Form.Item name="id" style={{ display: 'none' }}></Form.Item>

      <Form.Item name="username" label="账号">
        {user.username}
      </Form.Item>

      <Form.Item
        name="password"
        label="密码"
        rules={[
          { required: true },
          {
            validator(_, value) {
              if (value.length < 6) {
                return Promise.reject('密码不能少于6个字符')
              }
              if (value.length > 20) {
                return Promise.reject('密码不能超过20个字符')
              }
              return Promise.resolve()
            },
          },
        ]}
        maxLength={10}
      >
        <Input.Password placeholder="请输入初始密码" autoComplete='off'/>
      </Form.Item>
      <Form.Item
        name="confirmPassword"
        label="确认密码"
        rules={[
          { required: true },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve()
              }
              return Promise.reject(new Error('两次密码不一样'))
            },
          }),
        ]}
        maxLength={10}
      >
        <Input.Password placeholder="请输入确认密码" autoComplete='off'/>
      </Form.Item>
    </Form>
  )
}
